const products = [
  {
    id: "recZkNf2kwmdBcqd0",
    name: "accent chair",
    image:
      "https://res.cloudinary.com/dt2g7mgtv/image/upload/v1681749482/react-comfy-store-products/iuYyO9RP_o_upinxq.jpg",
  },
  {
    id: "recEHmzvupvT8ZONH",
    name: "albany sectional",

    image:
      "https://res.cloudinary.com/dt2g7mgtv/image/upload/v1681750782/react-comfy-store-products/product-2_lusrzx.jpg",
  },
  {
    id: "rec5NBwZ5zCD9nfF0",
    name: "albany table",

    image:
      "https://res.cloudinary.com/dt2g7mgtv/image/upload/v1681750874/react-comfy-store-products/product-3_znpiqa.jpg",
  },
  {
    id: "recd1jIVIEChmiwhe",
    name: "armchair",

    image:
      "https://res.cloudinary.com/dt2g7mgtv/image/upload/v1681750929/react-comfy-store-products/product-4_ebl6q1.jpg",
  },
  {
    id: "recoM2MyHJGHLVi5l",
    name: "bar stool",
    image:
      "https://res.cloudinary.com/dt2g7mgtv/image/upload/v1681751026/react-comfy-store-products/product-5_n184nu.jpg",
  },
  {
    id: "watch",
    name: "Smart Watch",
    image:
      "https://images.unsplash.com/photo-1523275335684-37898b6baf30?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cHJvZHVjdHxlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    id: "recEHmzvupvT8ZONHeadphone",
    name: "Bluetooth Headphone",

    image:
      "https://images.hindustantimes.com/tech/rf/image_size_960x540/HT/p2/2020/02/21/Pictures/_42fd2380-546d-11ea-a3cd-8211a7b3c8e4.jpg",
  },
  {
    id: "rec5NBwZ5zCD9nfF0cam",
    name: "Camera",

    image:
      "https://www.godaddy.com/resources/wp-content/uploads/improve-product-images-camera.jpg",
  },
  {
    id: "recd1jIVIEChmiwhelips",
    name: "Lipstick",

    image:
      "https://st3.depositphotos.com/32772600/36822/v/450/depositphotos_368223610-stock-illustration-lipstick-lip-gloss-make-hand.jpg",
  },
  {
    id: "recoM2MyHJGHLVi5lheels",
    name: "Women Footwear",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/1/1f/Product_photography.jpg",
  },
  {
    id: "Laptop",
    name: "Top Laptop Brands",
    image:
      "https://cdn.pixabay.com/photo/2015/05/15/02/07/computer-767781_640.jpg",
  },
  {
    id: "#Cosmotics",
    name: "Cosmotics",
    image:
      "https://assets-global.website-files.com/60f35132d5febb6352ec9d81/625667a0ec4c4bfd07d5c381_-2eDYT4x6SrY-XzE0zMCpLRgZyfyROnEyUavlu37qHH-riGgK0dpf8akummVBaogqbCgFLftCN_-kRCvGgMwqbADvI5acSJZDED84yoDgrARo40zbb_wFo_QcPVOxWY5VwelR6DQ.jpeg",
  },
  {
    id: "recoM2MyHJGHLVi5l",
    name: "bar stool",
    image:
      "https://res.cloudinary.com/dt2g7mgtv/image/upload/v1681751026/react-comfy-store-products/product-5_n184nu.jpg",
  },
  {
    id: "watch",
    name: "Smart Watch",
    image:
      "https://images.unsplash.com/photo-1523275335684-37898b6baf30?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cHJvZHVjdHxlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    id: "recZkNf2kwmdBcqd0",
    name: "accent chair",
    image:
      "https://res.cloudinary.com/dt2g7mgtv/image/upload/v1681749482/react-comfy-store-products/iuYyO9RP_o_upinxq.jpg",
  },
];

export default products;
